import React from "react";
import "./Footer.css";
import instagram_icon from "../Assets/instagram_icon.png";
import whatsapp_icon from "../Assets/whatsapp_icon.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Footer Branding */}
        <div className="footer-branding"> 
        <p>POSHER</p>
          <p>Where Elegance Meets Simplicity!</p>
        </div>

        {/* About Section */}
        <FooterSection
          title="About Posher"
          links={[
            { text: "About Us", href: "/about" },          
            { text: "Refund Policy", href: "/refund" },
            { /*text: "Privacy Policy", href: "#" */},
          ]}
        />

        {/* Help Section */}
        <FooterSection
          title="Help"
          links={[
            { text: "FAQ's", href: "/faq" },
            { text: "Terms & Conditions", href: "/conditions" },
          ]}
        />

        {/* Contact Section */}
        <div className="footer-section">
          <h3>Contact Us</h3>
          <p>
            📍 Address: Flat 1, Anambra Court, Gaduwa Housing Estate, Abuja, Nigeria <br />
            📞 Phone: <a href="tel:+234816795913">+2348125408813</a> <br />
            ✉️ Email:{" "}
            <a href="mailto:byposher@gmail.com">byposher@gmail.com</a>
          </p>
        </div>

        {/* Social Media Section */}
<div className="footer-social">
  <h3>Follow Us</h3>
  <div className="footer-social-icons">
    <a
      href="https://www.instagram.com/posherofficial"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src={instagram_icon} alt="Instagram" />
    </a>
    <a
      href="https://wa.me/2348125408813" 
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src={whatsapp_icon} alt="WhatsApp" />
    </a>
  </div>
</div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>
          &copy; 2025 <span className="footer-logo">Posher</span> All Rights
          Reserved.
        </p>
      </div>
    </footer>
  );
};

// Reusable FooterSection Component
const FooterSection = ({ title, links }) => (
  <div className="footer-section">
    <h3>{title}</h3>
    <ul>
      {links.map((link, index) => (
        <li key={index}>
          <a href={link.href}>{link.text}</a>
        </li>
      ))}
    </ul>
  </div>
);

export default Footer;
